import React, { FormEvent, useState, useEffect } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import InputField from "../../components/InputField/InputField";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import 'react-datepicker/dist/react-datepicker.css';

import "./trainingform.css";
import { HiArrowSmallLeft } from "react-icons/hi2";
import { Button } from "react-bootstrap";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";


import APIList from "../../utils/constants/APIList";
import Select from "react-select"; 
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { customSingleSelectStyles, customStyles } from "../../utils/constants/CustomStyles.constants";
import formatDate from "../../utils/helpers/formatDate";

interface TrainingFormProps {
  initialValues?: {
    id?: number;
    name?: string;
    coverImage?: File | null;
    description?: string;
    groupsOrEmployees?: { id: number; name: string }[];
    allowMultipleAccess?: boolean;
    addAllEmployees?: boolean;
    externalTrainingLink?: string;
    closeDate?: string; // Format DD-MM-YYYY
    is_priority?: string;
    isExternalLinkEnabled?: boolean;
    selectedQuiz?: { id: number; name: string };
    selectedModule?: { id: number; name: string };
  };
}

const TrainingForm: React.FunctionComponent<TrainingFormProps> = ({
  initialValues,
}) => {
  const [data, setData] = useState<{ id: number; name: string }[]>([]);
  const [employeeSelection, setEmployeeSelection] = useState<string>(
    "Individual Employee"
  );
  const [groupData, setGroupData] = useState<{ id: number; name: string }[]>(
    []
  );
  const [imageSrc, setImageSrc] = useState<string>("");

  const [file, setFile] = useState<any>(null);
  const dispatch = useAppDispatch();
const [showErrorModal, setShowErrorModal] = useState(false);
const [showCropper, setShowCropper] = useState<boolean>(false);
const [croppedImageFile, setCroppedImageFile] = useState<File | null>(null);
  const [trainingDetails, setTrainingDetails] = useState({
    name: "",
    cover_img: null as File | null,
    description: "",
    groupsOrEmployees: [] as { id: number; name: string }[],
    allowMultipleAccess: false,
    addAllEmployees: false,
    externalTrainingLink: "",
    closeDate: "",
    selectedQuiz: { id: 0, name: "" },
    selectedModule: { id: 0, name: "" },
    is_priority: "",
    isExternalLinkEnabled: false,
    all_employee: 0,
  });
  const handleCloseErrorModal = () => setShowErrorModal(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const [selectedCloseDate, setSelectedCloseDate] = useState<Date | null>(null)

  useEffect(() => {
    const fetchPeople = async () => {
      try {
        const response = await postDetails(APIList.GET_ALL_PEOPLE, {});
        // console.log("Fetched People:", response.data); // Debug log
        setData(response.data);
      } catch (error) {
        console.error("Failed to fetch people:", error);
      }
    };

    const fetchTrainingDetails = async (trainingId: number) => {
      try {
        const response = await postDetails(APIList.GET_TRAINING_DATA, {
          id: trainingId,
        });
        if (response.data) {
          const details = response.data;
          setTrainingDetails({
            name: details.name || "",
            cover_img: null,
            description: details.description || "",
            groupsOrEmployees:
              details.trainee_ids?.map((id: number) => ({ id, name: "" })) ||
              [],
            allowMultipleAccess: details.multiple_attempts === 1,
            addAllEmployees: details.addAllEmployees || false,
            externalTrainingLink: details.external_link || "",
            closeDate: details.closeDate || "",
            is_priority: details.is_priority === 1 ? "1" : "",
            isExternalLinkEnabled: !!details.external_link,
            selectedQuiz: details.selectedQuiz || { id: 0, name: "" },
            selectedModule: details.selectedModule || { id: 0, name: "" },
            all_employee: 0,
          });
        }
      } catch (error) {
        console.error("Failed to fetch training details:", error);
      }
    };

    fetchPeople();

    if (id) {
      fetchTrainingDetails(Number(id));
    } else if (initialValues) {
      console.log("Initial Values:", initialValues); // Debug log
      setTrainingDetails((prev) => ({ ...prev, ...initialValues }));
    }
  }, [id, initialValues]);

  const handleInputChange = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = ev.target;
    const isCheckbox = type === "checkbox";
    const isChecked = isCheckbox
      ? (ev.target as HTMLInputElement).checked
      : false;

    if (name === "addAllEmployees") {
      setTrainingDetails({
        ...trainingDetails,
        addAllEmployees: isChecked,
        groupsOrEmployees: isChecked ? data : [],
      });
    } else if (name === "is_priority") {
      setTrainingDetails({
        ...trainingDetails,
        is_priority: isChecked ? "1" : "",
      });
    } else if (name === "externalTrainingLink" && !isCheckbox) {
      setTrainingDetails({
        ...trainingDetails,
        externalTrainingLink: value,
      });
    } else if (name === "closeDate") {
      
      setTrainingDetails({
        ...trainingDetails,
        closeDate: value ? formatDateForSaving(value) : "",
      });
    } else {
      setTrainingDetails({
        ...trainingDetails,
        [name]: isCheckbox ? isChecked : value,
      });
    }
  };

  
  const handleCheckboxChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = ev.target;
    if (name === "is_priority") {
      setTrainingDetails({
        ...trainingDetails,
        is_priority: checked ? "1" : "", // Set "1" when checked, "" when unchecked
      });
    } else if (name === "externalTrainingLink") {
      setTrainingDetails({
        ...trainingDetails,
        externalTrainingLink: checked
          ? trainingDetails.externalTrainingLink
          : "",
        isExternalLinkEnabled: checked,
      });
    } else {
      setTrainingDetails({
        ...trainingDetails,
        [name]: checked,
      });
    }
  };

  const handleFileChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = ev.target.files?.[0];
  
    if (selectedFile) {
      const validation = validateImageFile(selectedFile);
      if (!validation.valid) {
        dispatch(showToast(validation.message));
        setTimeout(() => dispatch(hideToast()), 3000);
        ev.target.value = "";
        return;
      }

      if (selectedFile.size > 11 * 1024 * 1024) { 
        // alert("Image size is too big. Please select a file smaller than 10MB.");
        dispatch(showToast("Image size is too big. Please select a file smaller than 10MB."));
      setTimeout(() => dispatch(hideToast()), 3000);
        ev.target.value = ""; 
        return;
      }
  
      setFile(selectedFile);
  
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result as string);
      };
      reader.readAsDataURL(selectedFile); 
      setShowCropper(true);
    }
  };
  
  
  

  const handleSelectChange = (selectedOptions: any) => {
    setTrainingDetails({
      ...trainingDetails,
      groupsOrEmployees: selectedOptions
        ? selectedOptions.map((option: any) => ({
            id: option.value,
            name: option.label,
          }))
        : [],
    });
  };
  const handleCrop = (croppedImageDataURL: string) => {
    fetch(croppedImageDataURL)
      .then((res) => res.blob())
      .then((blob) => {
        const croppedFile = new File([blob], "croppedImage.jpg", { type: "image/jpeg" });
  
        setCroppedImageFile(croppedFile);  
  
        setTrainingDetails({
          ...trainingDetails,
          cover_img: croppedFile,
        });
  
        setImageSrc(croppedImageDataURL);
        setShowCropper(false);
      })
      .catch((err) => console.error("Error converting cropped image to blob:", err));
  };
  const handleSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
  
    console.log("submit is called");
    
    // if (croppedImageFile && croppedImageFile.size < 11 * 1024 * 1024) { 
    //   return; 
    // }
  
    if (!trainingDetails.closeDate) {
      dispatch(showToast("Please fill the Close Date."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }
  
    const formData = new FormData();
  
    const formattedData = {
      name: trainingDetails.name,
      description: trainingDetails.description,
      trainee_ids:
        trainingDetails.all_employee === 1
          ? data.map((employee) => employee.id)
          : trainingDetails.groupsOrEmployees.map((employee) => employee.id),
      is_priority: trainingDetails.is_priority !== "" ? 1 : 0,
      multiple_attempts: trainingDetails.allowMultipleAccess ? 1 : 0,
      external_link:
        trainingDetails.isExternalLinkEnabled &&
        trainingDetails.externalTrainingLink
          ? trainingDetails.externalTrainingLink
          : null,
      closeDate: trainingDetails.closeDate || undefined,
      all_employee: trainingDetails.all_employee,
      status: 0,
    };
  
  
    if (croppedImageFile) {
      formData.append("cover_img", croppedImageFile);
    }  else {
      console.error("No file selected");
    }
  
    formData.append("data", encrypt(formattedData));
  
    try {
      dispatch(showLoader("Loading data..."));
  
      const response = await postMultipartDetails(APIList.CREATE_TRAINING, formData);
  
      if (response.statusCode === 200) {
        navigate("/trainings", {
          state: { isExternalLinkEnabled: trainingDetails.isExternalLinkEnabled },
        });
      }
    
      else if (response.message == 'Data already present'){
        dispatch(showToast("Data already present"));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
      else {
        console.log(response)
        dispatch(showToast("Please fill form Properly"));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
    } catch (error) {
      dispatch(showToast("Something Went Wrong"));
      setTimeout(() => dispatch(hideToast()), 3000);
      console.error("Failed to submit training details:", error);
    } finally {
      dispatch(hideLoader());
    }
  };
  
 

  const handleCloseDateChange = (date: Date | null) => {
    setSelectedCloseDate(date); 
    if(date){
      setTrainingDetails((prevValue:any)=>({
      ...prevValue,
      closeDate: format(date, 'yyyy-MM-dd')
    }))
  }
  else{
    setTrainingDetails((prevValue:any)=>({
      ...prevValue,
      closeDate: ""
    }))
  }
  };
  
  const handleDropdownChange = async (selectedOption: any) => {
    const selectedValue = selectedOption.value;

    setEmployeeSelection(selectedValue);

    if (selectedValue === "All Employees") {
      setTrainingDetails((prevDetails) => ({
        ...prevDetails,
        all_employee: 1,
        groupsOrEmployees: [],
      }));
    } else if (selectedValue === "Group") {
      setTrainingDetails((prevDetails) => ({
        ...prevDetails,
        all_employee: 2,
        groupsOrEmployees: [],
      }));

      try {
        const response = await postDetails(APIList.GET_ALL_GROUPS, {});
      
        setGroupData(response.data);
      } catch (error) {
        console.error("Failed to fetch group data:", error);
      }
    } else {
      setTrainingDetails((prevDetails) => ({
        ...prevDetails,
        all_employee: 0,
      }));
    }
  };

  const dropdownOptions = [
    { value: "Individual Employee", label: "Individual Employee" },
    { value: "All Employees", label: "All Employees" },
    { value: "Group", label: "Group" },
  ];

  // const formatDateForInput = (date: string) => {
  //   if (!date) return "";
  //   const [day, month, year] = date.split("-");
  //   return `${year}-${month}-${day}`;
  // };
  const formatDateForInput = (date: string | number | Date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;
  };
  const handleDateChange = (date: any) => {
    setTrainingDetails((prevState) => ({
      ...prevState,
      closeDate: date,
    }));
  };

  const formatDateForSaving = (date: string) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const buttons = [
    {
      label: "Back to Training",
      theme: "warning",
      icon: <HiArrowSmallLeft />,
      onClick: () => navigate("/trainings"),
    },
  ];

  const options = data.map((item) => ({ value: item.id, label: item.name }));

  return (
    <LayoutContainer title={id ? "Edit Training" : "Add Training"}>
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-plus"></i>
          {id ? "Edit Training" : "Create Training"}
        </h2>
        <PageHeader buttons={buttons} />
      </div>

      <div className="main-training">
        <form onSubmit={handleSubmit}>
          <div className="training-form">
            <div className="nameTraining">
              <label htmlFor="nameOfTraining">Name of Training <span style={{ color: 'red' }}>*</span></label>
              <InputField
                name="name"
                id="nameOfTraining"
                type="text"
                placeholder="Enter Name of Training"
                value={trainingDetails.name}
                onChangeInput={handleInputChange}
                required={true}
                maxLength={200}
              />
              <div className="character-coun">
                {(trainingDetails.name).length}/{200}
              </div>
            </div>

            <div className="training-image">
              <label htmlFor="cover_img">Choose Cover Image <span style={{ color: 'red' }}>*</span></label>
              <input
                type="file"
                name="cover_img"
                id="cover_img"
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
                required={true}
              />
              {trainingDetails.cover_img && (
                <img
                  src={URL.createObjectURL(trainingDetails.cover_img)}
                  alt="Cover Preview"
                  className="cover-image-preview"
                />
              )}
            </div>

            <div className="desc">
              <label htmlFor="description">Add Description: <span style={{ color: 'red' }}>*</span></label>
              {/* <textarea
                name="description"
                id="description"
                placeholder="Add Description"
                value={trainingDetails.description}
                onChange={handleInputChange}
                required={true}
              /> */}
              {/* <InputField
                name="description"
                label=""
                type="text"
                value={trainingDetails.description}
                placeholder="Enter Description"
                maxLength={500}
                required={true}
                onChangeInput={handleInputChange}
              /> */}
               <textarea
    name="description"
    value={trainingDetails.description}
    placeholder="Enter Description"
    maxLength={500}
    required={true}
    onChange={handleInputChange}
    rows={5} 
    className="description-box"
  />
              <div className="character-coun">
                {(trainingDetails.description).length}/{500}
              </div>
            </div>


            <div className="close-date">
              {/* <label htmlFor="closeDate">Close Date:</label> */}
              <label htmlFor="closeDate">
  Close Date: <span style={{ color: 'red' }}>*</span>
</label>

              {/* <InputField
                type="date"
                name="closeDate"
                id="closeDate"
                value={formatDateForInput(trainingDetails.closeDate)}
                onChangeInput={handleInputChange}
              /> */}
              <DatePicker
            id="closeDate"
            name="closeDate"
            selected={selectedCloseDate}
            onChange={handleCloseDateChange}
            dateFormat="dd-MM-yyyy"
            showMonthDropdown 
            showYearDropdown   
            dropdownMode="select"
            minDate={new Date()}
            onKeyDown={(e:any)=> {e.preventDefault()}}
            placeholderText="Close Date"
            className={`mf-admin-inputfield`}
            // onBlur={handleDatePickerOnBlur}
            // required={true}
            isClearable
          />
                  
              

{/* <input
        type="date"
        id="closeDate"
        name="closeDate"
        value={formatDateForInput(trainingDetails.closeDate)}
        onChange={handleInputChange}
         onFocus={handleFocus}
        onBlur={handleBlur}
      /> */}
              
            </div>

            <div className="employee-selection">
              <label htmlFor="employeeSelection">Employee Selection</label>
              <Select
                name="employeeSelection"
                id="employeeSelection"
                styles={customSingleSelectStyles}
                options={[
                  {
                    value: "Individual Employee",
                    label: "Individual Employee",
                  },
                  { value: "All Employees", label: "All Employees" },
                  { value: "Group", label: "Group" },
                ]}
                value={{ value: employeeSelection, label: employeeSelection }}
                onChange={handleDropdownChange}
                placeholder="Select Employee Type"
                required={true}
              />
              
            </div>

            {trainingDetails.all_employee !== 1 && (
              <div className="group-employees">
                <label htmlFor="groupsOrEmployees">
                  Add Group or Employees <span style={{ color: 'red' }}>*</span>
                </label>
                <Select
  isMulti
  styles={customStyles}
  name="groupsOrEmployees"
  id="groupsOrEmployees"
  options={
    trainingDetails.all_employee === 2
      ? groupData
          .sort((a, b) => a.name.localeCompare(b.name)) // Sorting alphabetically A-Z
          .map((item) => ({
            value: item.id,
            label: item.name,
          }))
      : data
          .sort((a, b) => a.name.localeCompare(b.name)) // Sorting alphabetically A-Z
          .map((item) => ({
            value: item.id,
            label: item.name,
          }))
  }
  value={trainingDetails.groupsOrEmployees.map((item) => ({
    value: item.id,
    label: item.name,
  }))}
  onChange={handleSelectChange}
  placeholder="Select Groups or Employees"
/>

              </div>
            )}
            <div className="check-one">
              <label>
                <input
                  type="checkbox"
                  name="externalTrainingLink"
                  checked={trainingDetails.isExternalLinkEnabled}
                  onChange={handleCheckboxChange}
                />
                External Training Link
              </label>
            </div>

            {trainingDetails.isExternalLinkEnabled && (
              <div className="external-link">
                <label htmlFor="externalLink">External Training Link: </label>
                <InputField
                  name="externalTrainingLink"
                  id="externalLink"
                  type="text"
                  placeholder="Enter External Training Link"
                  value={trainingDetails.externalTrainingLink}
                  onChangeInput={handleInputChange}
                />
              </div>
            )}

            <div className="check-one">
              <label>
                <input
                  type="checkbox"
                  name="is_priority"
                  checked={trainingDetails.is_priority !== ""}
                  onChange={handleCheckboxChange}
                />
                Is-Priority
              </label>
            </div>
          </div>
          <hr></hr>
          <div className="form-buttons">
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-training-submit text-white">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      
      <CroppingModal
        show={showCropper}
        handleClose={() => setShowCropper(false)}
        image={imageSrc || ""}
        onCrop={handleCrop}
      />
    </LayoutContainer>
  );
};

export default TrainingForm;
